var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecieved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FF8A00",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.96 18.2688L26.96 12.25C26.6661 12.0876 26.3358 12.0024 26 12.0024C25.6642 12.0024 25.3339 12.0876 25.04 12.25L14.04 18.2713C13.7259 18.4432 13.4636 18.6962 13.2807 19.0041C13.0978 19.3119 13.0008 19.6632 13 20.0213V31.9763C13.0008 32.3344 13.0978 32.6857 13.2807 32.9935C13.4636 33.3013 13.7259 33.5544 14.04 33.7263L25.04 39.7475C25.3339 39.9099 25.6642 39.9951 26 39.9951C26.3358 39.9951 26.6661 39.9099 26.96 39.7475L37.96 33.7263C38.2741 33.5544 38.5364 33.3013 38.7193 32.9935C38.9023 32.6857 38.9992 32.3344 39 31.9763V20.0225C38.9999 19.6638 38.9032 19.3117 38.7203 19.0032C38.5373 18.6946 38.2747 18.441 37.96 18.2688ZM26 14L36.0425 19.5L32.3213 21.5375L22.2775 16.0375L26 14ZM26 25L15.9575 19.5L20.195 17.18L30.2375 22.68L26 25ZM15 21.25L25 26.7225V37.4463L15 31.9775V21.25ZM37 31.9725L27 37.4463V26.7275L31 24.5388V29C31 29.2652 31.1054 29.5196 31.2929 29.7071C31.4804 29.8947 31.7348 30 32 30C32.2652 30 32.5196 29.8947 32.7071 29.7071C32.8946 29.5196 33 29.2652 33 29V23.4438L37 21.25V31.9713V31.9725Z",
    fill: "#FF8A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecieved);
export default __webpack_public_path__ + "static/media/recieved.6a3a2ecf30d6acdae50f35076f482bb9.svg";
export { ForwardRef as ReactComponent };